"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _createStyles = _interopRequireDefault(require("../createStyles"));

var _Button = _interopRequireDefault(require("../Button"));

var _composeEvent = _interopRequireDefault(require("../utils/composeEvent"));

var _excluded = ["className", "style", "children", "onClick", "selected", "variant", "value", "jss"];
var useStyles = (0, _createStyles["default"])(function (theme) {
  return {
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      width: '100%',
      padding: "0px ".concat(theme.spacer(4), "px"),
      transition: theme.transition.create('background-color'),
      '&:last-child': {
        marginBottom: '0 !important'
      }
    },
    hover: {
      '&:hover': {
        borderRadius: 0,
        backgroundColor: theme.palette.action.selected
      }
    },
    height: {
      minHeight: 45
    },
    selected: {
      color: theme.palette.primary["default"],
      backgroundColor: theme.palette.action.selected
    }
  };
}, {
  name: 'ListItem'
});
exports.useStyles = useStyles;

var ListItem = /*#__PURE__*/_react["default"].forwardRef(function ListItem(_ref, ref) {
  var _cn;

  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      children = _ref.children,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? _noop["default"] : _ref$onClick,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? false : _ref$selected,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'li' : _ref$variant,
      value = _ref.value,
      _ref$jss = _ref.jss,
      jss = _ref$jss === void 0 ? {} : _ref$jss,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classes = useStyles({
    jss: jss
  });
  var isButton = variant === 'button';
  var listItemProps = {};
  var Component = isButton ? _Button["default"] : 'li';

  var handleMenuItemClick = function handleMenuItemClick(e) {
    (0, _composeEvent["default"])(e, {
      value: value
    });
    onClick(e, value);
  };

  if (isButton) {
    listItemProps = {
      onClick: handleMenuItemClick,
      value: value,
      component: 'span'
    };
  }

  return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, listItemProps, {
    ref: ref,
    className: (0, _classnames["default"])(classes.root, classes.height, (_cn = {}, (0, _defineProperty2["default"])(_cn, classes.hover, isButton), (0, _defineProperty2["default"])(_cn, classes.selected, isButton && selected), _cn), className),
    style: style
  }), children);
});

ListItem.propTypes = {
  /** The list item inner component to render */
  children: _propTypes["default"].node.isRequired,

  /** Additional class to add to the list item component */
  className: _propTypes["default"].string,

  /** Additional style to add to the list item component */
  style: _propTypes["default"].shape(),

  /** Value to pass on list click (only relevant for clickable list items) */
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].shape()]),

  /** CB for handling list item click event */
  onClick: _propTypes["default"].func,

  /** Indicator whether or not the list item is selected */
  selected: _propTypes["default"].bool,

  /** Set the type of menu item - values = ['li', 'button'] */
  variant: _propTypes["default"].oneOf(['li', 'button']),

  /** JSS overrides */
  jss: _propTypes["default"].oneOfType([_propTypes["default"].shape(), _propTypes["default"].func])
};
ListItem.displayName = 'ListItem';
var _default = ListItem;
exports["default"] = _default;